module.exports = __webpack_public_path__ + "assets/manual_journals-97e3cac5924f069f3bcd560b3cad3b73.pdf";